import { render, staticRenderFns } from "./PowerSub.vue?vue&type=template&id=28853417&"
import script from "./PowerSub.vue?vue&type=script&lang=js&"
export * from "./PowerSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports